export default __webpack_public_path__ + "static/media/formplay.02d5dace.svg";